const MAP_STYLE = [{"featureType": "administrative","elementType": "labels.text.fill","stylers": [{"color": "#444444"}]},{"featureType": "landscape","elementType": "all","stylers": [{"color": "#FFF8F3"}]},{"featureType": "poi","elementType": "all","stylers": [{"visibility": "off"}]},{"featureType": "road","elementType": "all","stylers": [{"saturation": -100},{"lightness": 45}]},{"featureType": "road.highway","elementType": "all","stylers": [{"visibility": "simplified"}]},{"featureType": "road.arterial","elementType": "labels.icon","stylers": [{"visibility": "off"}]},{"featureType": "transit","elementType": "all","stylers": [{"visibility": "off"}]},{"featureType": "water","elementType": "all","stylers": [{"color": "#79906A"},{"visibility": "on"}]},{"featureType": "water","elementType": "geometry","stylers": [{"color": "#79906A"}]}]

const MAP_OPTIONS = {
  selectors: {
    form: '.mlmi-locator-form',
    list: '.locations-list',
    where: 'input[name="where"]',
    radius: 'select[name="radius"]',
  },
  basicOptions: {
    zoom: 8,
    maxZoom: 18,
    minZoom: 5,
    lat: 45.60495258760901,
    lng: -73.71906734960938,
    mapStyle: MAP_STYLE,
    autoFitBounds: false,
    enableGeolocation: false,
    putSearchParametersInURL: false,
  },
  clusterOptions: {
    useClusters: false,
  },
  bubbleOptions: {
    useBubbles: false,
  },
  getMarkerIcon: function() {
    let markerIcon = {
      url: '/img/elements/map-marker.svg',
      height: 30,
      width: 19,
      anchorY: 30,
      anchorX: 8.5,
      scaledHeight: 30,
      scaledWidth: 19,
    }
    return markerIcon
  },
}

let self

export default {
  locator: undefined,
  locations: [],

  init() {
    self = this
    this.attachEvents()
  },

  markerClicked(event, locator, marker) {
    $('.location-item').removeClass('location-item--selected')
    let locationItem = $('.location-item[data-id=' + marker.location.id + ']')
    locationItem.addClass('location-item--selected')
    $('html, body').scrollTo(locationItem.offset().top - $('.header-wrapper').height() - 32, 'easeInOutQuart')
  },

  attachEvents() {
    if ($('.mlmi-locator-map').length) {
      /* Initialize map when ready */
      if ("MLMI_Locator_Function" in window) {
        $.fn.MLMI_Locator = window.MLMI_Locator_Function
      }
      if ($.fn.MLMI_Locator == undefined) {
        setTimeout(self.attachEvents, 50)
      } else {
        /* Initialize map */
        if ($.mlmi.mobile.isMobile) {
          MAP_OPTIONS.basicOptions.zoom = 9
        }
        self.locator = $('.mlmi-locator-map').MLMI_Locator(MAP_OPTIONS)

        /* Search */
        self.locator.on('search_started', function() {
          self.locator.addClass('mlmi-locator-map--loading')
          let targetTop = self.locator.offset().top - $('.header-wrapper').height()
          $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
        })
        self.locator.on('list_loaded', function() {
          self.locator.removeClass('mlmi-locator-map--loading')
          self.locator.options.basicOptions.autoFitBounds = true
        })

        /* Marker clicked */
        self.locator.on('marker_clicked', self.markerClicked)
      }
    }
  },
}
